/**
 * The code is based on 'ng2-file-upload' library (https://github.com/valor-software/ng2-file-upload)
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Dmitriy Shekhovtsov <valorkin@gmail.com>
 * Copyright (c) 2015 Valor Software
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

export class FileLikeObject {
    lastModifiedDate?: Date;
    size = 0;
    type?: string;
    name?: string;
    rawFile: HTMLInputElement | File;

    constructor(fileOrInput: HTMLInputElement | File) {
        this.rawFile = fileOrInput;
        if (fileOrInput instanceof HTMLInputElement) {
            this._createFromFakePath(fileOrInput.value);
        } else {
            this._createFromObject(fileOrInput);
        }
    }

    private _createFromFakePath(path: string): void {
        this.lastModifiedDate = new Date();
        this.size = 0;
        this.type = `like/${path.slice(path.lastIndexOf(".") + 1).toLowerCase()}`;
        this.name = path.slice(path.lastIndexOf("/") + path.lastIndexOf("\\") + 2);
    }

    private _createFromObject(object: { size: number; type: string; name: string }): void {
        this.size = object.size;
        this.type = object.type;
        this.name = object.name;
    }
}
